import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-and-privacy',
  templateUrl: './terms-and-privacy.component.html',
  styleUrls: ['./terms-and-privacy.component.scss']
})
export class TermsAndPrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
